import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateLeagueList = {
  leagueList: { data: null, loading: false, error: null },
};

export const leagueList = createAsyncThunk('user/leagueList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/league/list`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerLeagueList = {
  [leagueList.pending]: (state) => {
    state.leagueList.loading = true;
  },
  [leagueList.fulfilled]: (state, action) => {
    state.leagueList.loading = false;
    state.leagueList.data = action.payload;
    state.leagueList.error = null;
  },
  [leagueList.rejected]: (state, action) => {
    state.leagueList.data = null;
    state.leagueList.loading = false;
    state.leagueList.error = action.payload;
  },
};
